import React, { useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Empty from '../../../Assets/img_empty.png'

const Style = styled.div`
    @keyframes fade-in-anim1 {
        0% {
            opacity: 0;
            top: 6rem
        }
        100%  {
            opacity: 1;
            top: 0;
        }
    }
    display: grid;
    grid-template-columns: repeat(3 , calc(calc(100% / 3) - 1rem));
    grid-gap: 1.5rem;
    color: var(--text-3);
    width: 100%;
    min-height: 20rem;
    margin-bottom: 3rem;
    position: relative;
    padding-top: 1rem;
    .title-blog{
        grid-column: 1/4;
        top: 0;
        right: 0;
        font-weight: 500;
        font-size: 2rem;
        color: var(--fsc-d-1);
    }
    .row-anime{
        overflow: hidden;
        animation: fade-in-anim1 0.8s ease-in-out 1 0s forwards;
    }
    .row{
        position: relative;
        display: flex;
        flex-direction: row;
        text-decoration: none;
        color: var(--text-3);
        border-radius: 8px;
        width: 100%;
        background: #f5faff;
        box-shadow: var(--n-shadow-1);
        transition: all 0.2s ease-in-out;
        .title{
            font-weight: 700;
            font-size: 1.2rem;
            color: var(--prime-3);
            width: 100%;
        }
        
        :hover{
            box-shadow: var(--n-shadow-4);
            .title{
                /* font-size: 1.3rem; */
            }
        }
    }
    .row1-g{
        display: flex;
        flex-direction: column;
        justify-content: baseline;
        align-items: center;
        opacity: 0;
        .row1-txt{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            font-weight: 400;
            font-size: 1rem;
            color: var(--fsc-d-1);
            height: 20%;
            position: relative;
            width: calc(100% - 1rem);
            padding: 0.5rem;
            .summery{
                margin: 0.4rem 0;
                color: var(--text-3);
                font-size: 1rem;
                font-weight: 400;
                text-overflow: ellipsis;
            }
        }
        .row1-img{
            width: 100%;
            /* height: 80%; */
            display: block;
            aspect-ratio: 1.5/1;
            object-fit: cover;
        }
        
    }
 
    .row2-g{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        opacity: 0;
        height: 12rem;
        .row2-txt{
            display: flex;
            flex-direction: column;
            text-align: left;
            justify-content: end;
            font-weight: 400;
            font-size: 1rem;
            color: var(--fsc-d-1);
            margin-left: 1rem;
            width: calc(65% - 1rem);
        }
        .row2-img{
            width: 35%;
            aspect-ratio: 1;
            margin: auto;
        }
        
    }
    
    .row3-g{
        padding: 0;
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: 30rem;
        text-align: justify;
        justify-content: center;
        background: var( --background-1);
        opacity: 0;
        .row3-txt{
            width: calc(100% - 2rem);
            position: relative;
            padding: 1rem;
            font-size: 1rem;
            font-weight: 400;
            border-radius: 8px;
            display: flex;
            justify-content: center;
        }
        .title{
            justify-content: center;
            margin: auto;
        }
        .row3-img{
            width: 60%;
            margin: auto;
            aspect-ratio: 1;
            position: relative;
            /* box-shadow: var(--n-shadow-1); */
            background: var( --background-1);
        }

    }
    .row4-g{
        grid-column: span 4;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 2rem;
        width: calc(100% - 4rem);
        .row4-img{
            width: 20%;
            aspect-ratio: 1;
            display: flex;
            object-fit: cover;
            margin-right:1rem  ;
        }
        .title{
            margin-bottom: 1rem;
        }
        .row4-txt{
            display: flex;
            flex-direction: row;
            width: 100%;
            .row4-summ{
                font-size: 1rem;
                font-weight: 400;
            }

        }
        :nth-child(odd){
            .row4-img{
                margin-right: 0;
                margin-left: 1rem;
            }
            .row4-txt{
                flex-direction: row-reverse;
            }
        }
    }
    
    @media screen and (max-width: 850px){
        grid-template-columns: 1fr;
        grid-auto-rows: auto;
        grid-gap: 0;
        grid-row-gap: 1rem;
        .title-blog{
            font-size: 1.2rem;
        }
        .row-anime{
            opacity: 1;
        }
        .row1-g{
            grid-column: 1/4;
            grid-row: 1 span;
            /* flex-direction: row; */
            /* justify-content: space-between; */
            padding-bottom: 0;
            align-items: flex-start;

            /* .row1-img{
                width: 50%;
                height: 100%;
                aspect-ratio: 1;
            }
            .row1-txt{
                width: calc(50% - 0.8rem);
                padding: 0.4rem;
                justify-content: flex-start;
                align-items: flex-start;
            } */
        }

        .row2-g{
            height: 10rem;
        }
        .row4-g{
            padding: 1rem;
            width: calc(100% - 2rem);
            .title{
                font-size: 1rem;
            }
            .row4-txt .row4-summ{
                font-size: 0.8rem;
            }
            .row4-img{
                width: 35%;
            }
        }
    }
`
const GridRow = (props)=>{
    let data = props.data
    let row1Ref = useRef()
    let row3Ref = useRef()
    let row2Ref = useRef()
    let classAnime = ''
    if(window.innerWidth > 850){
        if(row1Ref?.current?.getBoundingClientRect()?.top){
            classAnime = 'row-anime'
        }else if(row2Ref?.current?.getBoundingClientRect()?.top <= window.innerHeight){
            classAnime = 'row-anime'
        }else if(row3Ref?.current?.getBoundingClientRect()?.top <= window.innerHeight){
            classAnime = 'row-anime'
        }
    }else{
        classAnime = 'row-anime'
    }
    let tit = (props.data.length ? props.data[0].Btype_Name : "")
    const typegrid =()=>{
        let show =data.map ((obj  , index)=>{
            let img = obj.BM_Image ?? Empty
            return(
                <Link className={"row1-g row " + classAnime} to={{ pathname:`/${props.language.filename}/lotus-blog/blog?id=${obj.ID}` , state:{id:obj.ID} }} key={index} ref={row1Ref}>
                    <img src={img} className="row1-img" alt={obj.BM_Title}/>
                    <div className="row1-txt">
                        <span className="title">{obj.BM_Title}</span>
                        <span className="title summery">{obj.BM_Summery}</span>
                    </div>
                </Link>
            )
        })
        return show
    }
    return(
        <Style key={props.type}>
            <span className="title-blog">{tit}</span>
            {typegrid()}
        </Style>
    );
}
export default GridRow